import { Navigate, Outlet } from 'react-router-dom';
import { isAdminSelector } from '../features/auth/selectors/auth.selectors';
import { useSelector } from 'react-redux';
import { Box } from '@cdl/heartbeat-react';

export const AdminRoute = () => {
  const admin = useSelector(isAdminSelector);
  if (!admin) return <Navigate to={'/'} replace />;
  return (
    <Box p='xl' pt='xxl' w='full'>
      <Box maxWidth='2000px' ml={'auto'} mr={'auto'}>
        <Outlet />
      </Box>
    </Box>
  );
};
